/**
 * 全局状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import navmenu from './modules/navmenu'
import common from './modules/common'
import login from './modules/login'
import ieditor from './modules/ieditor'
import irecord from './modules/irecord'
import press from './modules/press'
import audit from './modules/audit'
import stats from './modules/stats'
import joke from './modules/joke'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
    modules: {
        login,
        ieditor,
        irecord,
        audit,
        press,
        stats,
        navmenu,
        common,
        joke
    },
    strict: debug, //是否开启严格模式
    plugins: debug ? [createLogger()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js